import Lazy from '~/client/shared/LazyLoad/Lazy';
import type { LinkProps } from '~/client/shared/NextLink';
import DefaultSignupButton from './shared/DefaultSignupButton';
import LazySignupButton from './SignupButton';

type Props = {
  href?: LinkProps['href'];
  pulse?: boolean;
  onClick?: () => void;
};

const SignupButton: FC<Props> = (props) => (
  <Lazy placeholder={<DefaultSignupButton {...props} />}>
    <LazySignupButton {...props} />
  </Lazy>
);

export default SignupButton;
